// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Vertical timeline used by the booking stepper's workflow panels (variant="timeline"). */
.wf-tl-item {
  display: flex;
  gap: 14px;
  align-items: stretch;
}
.wf-tl-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 28px;
}
.wf-tl-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fde7ef;
  color: #c2185b;
  font-weight: 700;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.wf-tl-line {
  flex: 1 1 auto;
  width: 2px;
  background: #e3ebf8;
  margin-top: 4px;
}
.wf-tl-body {
  flex: 1 1 auto;
  min-width: 0;
  padding: 8px 0 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Vendor_bookings/workflow/WorkflowTimeline.css"],"names":[],"mappings":"AAAA,0FAA0F;AAC1F;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Vertical timeline used by the booking stepper's workflow panels (variant=\"timeline\"). */\n.wf-tl-item {\n  display: flex;\n  gap: 14px;\n  align-items: stretch;\n}\n.wf-tl-rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 28px;\n}\n.wf-tl-dot {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #fde7ef;\n  color: #c2185b;\n  font-weight: 700;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 8px;\n}\n.wf-tl-line {\n  flex: 1 1 auto;\n  width: 2px;\n  background: #e3ebf8;\n  margin-top: 4px;\n}\n.wf-tl-body {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 8px 0 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
